// extracted by mini-css-extract-plugin
export var articleBody = "newsArticle-module--article-body--tENwY";
export var authorBlock = "newsArticle-module--author-block--D7NM0";
export var authorImage = "newsArticle-module--author-image--7ClWZ";
export var newsLinks = "newsArticle-module--news-links--4xDq8";
export var readBlock = "newsArticle-module--read-block--cq4gk";